// extracted by mini-css-extract-plugin
module.exports = {"heading":"OurPeople-module_heading","wrap":"OurPeople-module_wrap","h55":"OurPeople-module_h55","img":"OurPeople-module_img","textSection":"OurPeople-module_textSection"};